import {  ADD_CONFIGURATION, VIEW_CONFIGURATION } from 'store/actions/configuration';

const initialState = {
    isAuthenticated: false,
    configuration: {},
    loader:false,
};

//add 
const addConfiguration = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      configuration:data.body,
    };
    return stateObj;
};

  //view 
const viewConfiguration = (state, payload) => {
    const { data, callback } = payload;
    if (typeof callback === 'function') {
        callback(payload);
    }
    const stateObj = {
      ...state,
      isAuthenticated: true,
      configuration:data.body,
    };
    return stateObj;
};

const Configuration = (state = initialState, { type, payload = null }) => {
    switch (type) {
        case ADD_CONFIGURATION:
            return addConfiguration(state, payload);
        case VIEW_CONFIGURATION:
          return viewConfiguration(state, payload);
        default:
        return state;
    };
}
export default Configuration;